import {ErrorBoundary} from "react-error-boundary";
import {CustomerDetailsSection} from "../../../components/customers/customer-details-section/customer-details-section";
import {CustomerMetricsSection} from "../../../components/customers/customer-metrics-section/customer-metrics-section";
import {DashboardWrapper} from "../../../layouts/dashboard-wrapper";
import {StyledCustomersPageWrapper} from "../../../styles/customers/customers";
import {StyledPageHeader} from "../../../styles/dashboard/calls/calls";
import {Alert, Button} from "antd";

const CustomersPage = () => {
  return (
    <DashboardWrapper pageTitle="Customers" pageSlug="/customers">
      {/* <StyledPageHeader>Customers 👥</StyledPageHeader> */}
      <StyledPageHeader>Customers</StyledPageHeader>
      <StyledCustomersPageWrapper>
        <ErrorBoundary
          FallbackComponent={({error, resetErrorBoundary}) => (
            <div>
              <Alert
                message="Sorry, something went wrong."
                showIcon
                description={error.message}
                type="error"
                action={
                  <Button
                    onClick={() => {
                      resetErrorBoundary();
                    }}
                    size="small"
                    danger
                  >
                    Reset
                  </Button>
                }
              />
            </div>
          )}
        >
          <CustomerMetricsSection />
          <CustomerDetailsSection />
        </ErrorBoundary>
      </StyledCustomersPageWrapper>
    </DashboardWrapper>
  );
};

export {CustomersPage};
